import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, FileText } from "lucide-react";
import { waLink } from "@/data/site";

export const MobileBar = () => {
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    const isField = (el) => el && ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName);
    const onIn = (e) => { if (isField(e.target)) setHidden(true); };
    const onOut = (e) => { if (isField(e.target)) setHidden(false); };
    document.addEventListener("focusin", onIn);
    document.addEventListener("focusout", onOut);
    return () => { document.removeEventListener("focusin", onIn); document.removeEventListener("focusout", onOut); };
  }, []);
  return (
    <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink px-3 pt-3 pb-safe transition-transform duration-300 md:hidden on-dark ${hidden ? "translate-y-full" : "translate-y-0"}`} data-testid="mobile-cta-bar">
      <div className="grid grid-cols-2 gap-3">
        <a href={waLink()} target="_blank" rel="noopener noreferrer" className="btn min-h-[48px] border border-white/20 text-white" data-testid="mobile-bar-whatsapp">
          <MessageCircle className="h-4 w-4" aria-hidden /> WhatsApp
        </a>
        <Link to="/contact#inquiry" className="btn min-h-[48px] bg-lime text-ink" data-testid="mobile-bar-quote">
          <FileText className="h-4 w-4" aria-hidden /> Get a Quote
        </Link>
      </div>
    </div>
  );
};

export const FloatingWhatsApp = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Athlevo IT Solution on WhatsApp"
    className="group fixed bottom-6 right-6 z-40 hidden h-14 items-center gap-0 overflow-hidden rounded-full bg-lime pl-4 pr-4 text-ink ring-1 ring-ink/10 shadow-[0_20px_40px_-15px_rgba(36,37,34,0.6)] transition-[padding] duration-500 hover:pr-6 md:flex"
    data-testid="floating-whatsapp"
  >
    <MessageCircle className="h-6 w-6" aria-hidden />
    <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-bold transition-[max-width,margin] duration-500 group-hover:ml-2 group-hover:max-w-[160px]">Chat on WhatsApp</span>
  </a>
);
